import CacheData from '../../../common/utils/cacheData';
import ServerData from '../../../common/serverData';
import {isDemoApartment, getFakePaymentData} from '../../../common/shared/statelessMethods';

const client = new ServerData();

export const paymentsCardType = {
    monthly: 'monthly',
    special: 'special',
};

export const fetchApartmentPaymentData = async (buildingID, apartmentNumber, accessToken, ownership, phone) => {
    if (isDemoApartment(buildingID, apartmentNumber)){
        return await getFakePaymentData(buildingID)
    }
    const cacheKey = 'apartmentPayments';
    const options = { buildingID, apartmentNumber };
    let search = window.location.search.substring(1);
    let params = new URLSearchParams(search);
    params = accessToken ? {...params, Authorization: `Bearer ${accessToken}`} : {...params, phone: phone?.slice(-7)};
    const url = `/tenants/payments/${buildingID}/${apartmentNumber}/${accessToken ? '' : (ownership ?? '')}`;
    const payments = await client.get(url, params);
    CacheData.cache(cacheKey, payments, options);

    return payments
};

/**
 * @param {string | number} buildingId
 * @param {string | number} apartmentNum
 * @returns {Promise<{
 * hasRenter: boolean,
 * hasOwner: boolean
 * }>}
 */
export const fetchTenantStatus = async (buildingId, apartmentNum) => {
    return await client.get(`/buildings/${buildingId}/apartment/${apartmentNum}/tenants/status`);
}
